var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowwLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "183pt",
    height: "50pt",
    viewBox: "0 0 183 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5367ff",
    stroke: "#5367ff",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 8.3 7.4 C 12.5 3.3 18.2 1.2 23.9 0.7 C 32.7 0.5 41.4 5.3 45.8 12.9 C 40.0 18.2 34.5 23.6 29.0 29.0 C 24.0 27.4 19.1 25.4 14.2 23.6 C 10.0 26.4 5.7 29.1 1.5 31.8 C -1.2 23.2 1.8 13.4 8.3 7.4 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ffc4",
    stroke: "#00ffc4",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 45.8 12.9 C 46.5 14.4 47.1 15.9 47.8 17.4 C 41.2 22.0 36.7 29.2 29.7 33.4 C 24.7 32.8 20.4 29.3 15.3 28.7 C 11.0 30.8 7.4 34.0 2.9 35.6 C 2.4 34.4 1.9 33.1 1.5 31.8 C 5.7 29.1 10.0 26.4 14.2 23.6 C 19.1 25.4 24.0 27.4 29.0 29.0 C 34.5 23.6 40.0 18.2 45.8 12.9 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 67.2 15.1 C 72.0 11.3 79.3 11.9 84.0 15.8 C 83.2 16.8 82.3 17.8 81.5 18.8 C 78.5 17.0 74.6 15.4 71.2 17.3 C 65.7 20.1 65.3 29.0 70.5 32.3 C 73.6 34.4 77.6 33.6 80.7 32.0 C 80.7 30.4 80.7 28.9 80.7 27.3 C 78.7 27.3 76.7 27.3 74.6 27.3 C 74.6 26.4 74.6 24.5 74.6 23.6 C 78.0 23.6 81.4 23.6 84.8 23.6 C 84.8 27.0 84.8 30.5 84.8 33.9 C 79.9 37.6 72.8 39.0 67.6 35.3 C 60.8 30.9 60.7 19.9 67.2 15.1 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ebb4",
    stroke: "#00ebb4",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 29.7 33.4 C 36.7 29.2 41.2 22.0 47.8 17.4 C 48.2 19.1 48.5 20.8 48.9 22.6 C 43.0 26.7 37.9 31.9 32.8 36.9 C 31.9 37.6 31.0 38.6 29.8 38.9 C 24.7 38.6 20.4 35.0 15.3 34.6 C 11.8 35.9 8.9 38.4 5.8 40.3 C 4.8 38.8 3.8 37.2 2.9 35.6 C 7.4 34.0 11.0 30.8 15.3 28.7 C 20.4 29.3 24.7 32.8 29.7 33.4 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 89.6 18.8 C 90.6 18.8 92.7 18.8 93.7 18.8 C 93.7 20.1 93.7 21.3 93.7 22.6 C 95.2 20.4 97.3 18.4 100.2 18.4 C 100.2 19.4 100.3 21.5 100.3 22.5 C 98.3 23.2 95.8 23.6 94.7 25.8 C 93.1 29.3 93.9 33.3 93.7 37.0 C 92.4 37.1 91.0 37.1 89.6 37.2 C 89.6 31.1 89.6 24.9 89.6 18.8 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 108.4 19.4 C 115.1 15.8 124.0 22.5 121.9 30.0 C 120.7 37.0 111.1 39.9 106.0 35.0 C 101.0 30.9 102.3 21.9 108.4 19.4 M 110.4 22.5 C 106.3 24.0 106.0 30.3 109.3 32.8 C 112.4 35.2 117.8 33.1 117.8 29.1 C 118.9 24.8 114.5 20.8 110.4 22.5 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 125.1 18.8 C 126.1 18.8 128.2 18.8 129.2 18.8 C 130.5 22.9 131.6 27.0 132.9 31.1 C 134.3 27.0 135.6 22.9 136.9 18.8 C 137.8 18.8 139.5 18.7 140.4 18.7 C 141.8 22.8 142.9 27.1 144.7 31.1 C 145.8 26.9 146.9 22.7 148.5 18.7 C 149.4 18.7 151.2 18.8 152.1 18.9 C 150.6 25.1 148.3 31.1 146.3 37.3 C 145.4 37.3 143.7 37.2 142.8 37.2 C 141.4 33.4 140.3 29.5 138.9 25.7 C 136.6 29.1 136.2 33.5 134.4 37.3 C 133.5 37.3 131.8 37.2 130.9 37.2 C 129.0 31.1 126.9 25.0 125.1 18.8 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 154.3 18.8 C 155.4 18.8 157.4 18.8 158.4 18.8 C 159.8 22.9 160.9 27.0 162.1 31.2 C 163.9 27.2 164.4 22.6 166.6 18.7 C 167.3 18.7 168.7 18.7 169.4 18.7 C 171.5 22.6 172.1 27.2 173.9 31.2 C 175.0 27.0 176.2 22.9 177.6 18.8 C 178.6 18.8 180.6 18.8 181.6 18.8 C 179.6 25.0 177.8 31.3 175.5 37.3 C 174.6 37.3 172.8 37.2 172.0 37.2 C 170.7 33.0 169.3 28.9 168.0 24.8 C 166.3 28.9 165.7 33.5 163.4 37.3 C 162.7 37.3 161.3 37.3 160.6 37.3 C 157.8 31.4 156.5 24.9 154.3 18.8 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d8a5",
    stroke: "#00d8a5",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 32.8 36.9 C 37.9 31.9 43.0 26.7 48.9 22.6 C 49.0 24.6 48.9 26.6 48.8 28.6 C 43.5 32.3 38.7 36.6 34.3 41.4 C 32.9 42.7 31.6 44.3 29.8 44.9 C 24.9 44.5 20.8 41.3 16.0 40.5 C 13.4 41.0 11.2 42.4 8.9 43.6 C 7.9 42.5 6.8 41.4 5.8 40.3 C 8.9 38.4 11.8 35.9 15.3 34.6 C 20.4 35.0 24.7 38.6 29.8 38.9 C 31.0 38.6 31.9 37.6 32.8 36.9 Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#00c798",
    stroke: "#00c798",
    strokeWidth: 0.09375,
    opacity: 1,
    d: " M 34.3 41.4 C 38.7 36.6 43.5 32.3 48.8 28.6 C 47.3 40.2 36.6 49.5 24.9 49.5 C 19.1 49.5 13.4 47.2 8.9 43.6 C 11.2 42.4 13.4 41.0 16.0 40.5 C 20.8 41.3 24.9 44.5 29.8 44.9 C 31.6 44.3 32.9 42.7 34.3 41.4 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowwLogo);
export default __webpack_public_path__ + "static/media/growwLogo.be895e1f4e27d909946ef03e8b2e7afa.svg";
export { ForwardRef as ReactComponent };